import { API_CALL } from "../../middleware/api";

export const GET_PATIENTS_WITHOUT_KIT = 'get-patients-without-kit';
export const GET_PATIENTS_WITHOUT_KIT_RESULT = `${GET_PATIENTS_WITHOUT_KIT}/result`;
export const GET_PATIENTS_WITHOUT_KIT_ERROR = `${GET_PATIENTS_WITHOUT_KIT}/error`;

export const CREATE_SHIPMENT = 'create-shipment';
export const CREATE_SHIPMENT_RESULT = `${CREATE_SHIPMENT}/result`;
export const CREATE_SHIPMENT_ERROR = `${CREATE_SHIPMENT}/error`;

export const EDIT_SHIPMENT = 'edit-shipment';
export const EDIT_SHIPMENT_RESULT = `${EDIT_SHIPMENT}/result`;
export const EDIT_SHIPMENT_ERROR = `${EDIT_SHIPMENT}/error`;

export const GET_SHIPMENTS = 'get-shipments';
export const GET_SHIPMENTS_RESULT = `${GET_SHIPMENTS}/result`;
export const GET_SHIPMENTS_ERROR = `${GET_SHIPMENTS}/error`;

export const GET_SHIPMENT_DETAILS = 'get-shipment-details';
export const GET_SHIPMENT_DETAILS_RESULT = `${GET_SHIPMENT_DETAILS}/result`;
export const GET_SHIPMENT_DETAILS_ERROR = `${GET_SHIPMENT_DETAILS}/error`;

export const UPDATE_SHIPMENT_STATUS = 'update-shipment-status';
export const UPDATE_SHIPMENT_STATUS_RESULT = `${UPDATE_SHIPMENT_STATUS}/result`;
export const UPDATE_SHIPMENT_STATUS_ERROR = `${UPDATE_SHIPMENT_STATUS}/error`;

export const TRANSFER_KITS = 'transfer-kits';
export const TRANSFER_KITS_RESULT = `${TRANSFER_KITS}/result`;
export const TRANSFER_KITS_ERROR = `${TRANSFER_KITS}/error`;

export const GET_INVENTORY_LIST = 'get-inventory-list';
export const GET_INVENTORY_LIST_RESULT = `${GET_INVENTORY_LIST}/result`;
export const GET_INVENTORY_LIST_ERROR = `${GET_INVENTORY_LIST}/error`;

export const GET_INVENTORY_SUMMARY = 'get-inventory-summary';
export const GET_INVENTORY_SUMMARY_RESULT = `${GET_INVENTORY_SUMMARY}/result`;
export const GET_INVENTORY_SUMMARY_ERROR = `${GET_INVENTORY_SUMMARY}/error`;

export const GET_ORDERS = 'get-orders';
export const GET_ORDERS_RESULT = `${GET_ORDERS}/result`;
export const GET_ORDERS_ERROR = `${GET_ORDERS}/error`;

export const CREATE_ORDER = 'create-order';
export const CREATE_ORDER_RESULT = `${CREATE_ORDER}/result`;
export const CREATE_ORDER_ERROR = `${CREATE_ORDER}/error`;

export const EDIT_ORDER = 'edit-order';
export const EDIT_ORDER_RESULT = `${EDIT_ORDER}/result`;
export const EDIT_ORDER_ERROR = `${EDIT_ORDER}/error`;

export const DELETE_ORDER = 'delete-order';
export const DELETE_ORDER_RESULT = `${DELETE_ORDER}/result`;
export const DELETE_ORDER_ERROR = `${DELETE_ORDER}/error`;

export const GET_ORDER = 'get-order';
export const GET_ORDER_RESULT = `${GET_ORDER}/result`;
export const GET_ORDER_ERROR = `${GET_ORDER}/error`;

export const GET_ORDERABLE_DEVICES = 'get-orderable-devices';
export const GET_ORDERABLE_DEVICES_RESULT = `${GET_ORDERABLE_DEVICES}/result`;
export const GET_ORDERABLE_DEVICES_ERROR = `${GET_ORDERABLE_DEVICES}/error`;

export const GET_ORDER_INVOICES = 'get-order-invoices';
export const GET_ORDER_INVOICES_RESULT = `${GET_ORDER_INVOICES}/result`;
export const GET_ORDER_INVOICES_ERROR = `${GET_ORDER_INVOICES}/error`;

export const GET_DEVICE_TIMELINE = 'get-device-timeline';
export const GET_DEVICE_TIMELINE_RESULT = `${GET_DEVICE_TIMELINE}/result`;
export const GET_DEVICE_TIMELINE_ERROR = `${GET_DEVICE_TIMELINE}/error`;

export const GET_INVOICES = 'get-invoices';
export const GET_INVOICES_RESULT = `${GET_INVOICES}/result`;
export const GET_INVOICES_ERROR = `${GET_INVOICES}/error`;

export const ACCEPT_ORDER = 'accept-order';
export const ACCEPT_ORDER_RESULT = `${ACCEPT_ORDER}/result`;
export const ACCEPT_ORDER_ERROR = `${ACCEPT_ORDER}/error`;

export const REJECT_ORDER = 'reject-order';
export const REJECT_ORDER_RESULT = `${REJECT_ORDER}/result`;
export const REJECT_ORDER_ERROR = `${REJECT_ORDER}/error`;

export const GET_REVIEW_QUEUE = 'get-review-queue';
export const GET_REVIEW_QUEUE_RESULT = `${GET_REVIEW_QUEUE}/result`;
export const GET_REVIEW_QUEUE_ERROR = `${GET_REVIEW_QUEUE}/error`;

export const GET_DELIVERY_FOLLOWUPS = 'get-delivery-followups';
export const GET_DELIVERY_FOLLOWUPS_RESULT = `${GET_DELIVERY_FOLLOWUPS}/result`;
export const GET_DELIVERY_FOLLOWUPS_ERROR = `${GET_DELIVERY_FOLLOWUPS}/error`;

export const SET_DELIVERY_FOLLOWUP = 'set-delivery-followup';
export const SET_DELIVERY_FOLLOWUP_RESULT = `${SET_DELIVERY_FOLLOWUP}/result`;
export const SET_DELIVERY_FOLLOWUP_ERROR = `${SET_DELIVERY_FOLLOWUP}/error`;

export const GET_PENDING_RETURNS = 'get-pending-returns';
export const GET_PENDING_RETURNS_RESULT = `${GET_PENDING_RETURNS}/result`;
export const GET_PENDING_RETURNS_ERROR = `${GET_PENDING_RETURNS}/error`;

export const GET_KITS_AWAITING_BULK_RETURN = 'get-kits-awaiting-bulk-return';
export const GET_KITS_AWAITING_BULK_RETURN_RESULT = `${GET_KITS_AWAITING_BULK_RETURN}/result`;
export const GET_KITS_AWAITING_BULK_RETURN_ERROR = `${GET_KITS_AWAITING_BULK_RETURN}/error`;

export const GET_KITS_FOR_INSPECTION = 'get-kits-for-inspection';
export const GET_KITS_FOR_INSPECTION_RESULT = `${GET_KITS_FOR_INSPECTION}/result`;
export const GET_KITS_FOR_INSPECTION_ERROR = `${GET_KITS_FOR_INSPECTION}/error`;

export const RELEASE_KIT_FROM_INSPECTION = 'release-kit-from-inspection';
export const RELEASE_KIT_FROM_INSPECTION_RESULT = `${RELEASE_KIT_FROM_INSPECTION}/result`;
export const RELEASE_KIT_FROM_INSPECTION_ERROR = `${RELEASE_KIT_FROM_INSPECTION}/error`;

export const GET_DEVICE_MAPPINGS = 'get-device-mappings';
export const GET_DEVICE_MAPPINGS_RESULT = `${GET_DEVICE_MAPPINGS}/result`;
export const GET_DEVICE_MAPPINGS_ERROR = `${GET_DEVICE_MAPPINGS}/error`;

export const SET_DEVICE_MAPPINGS = 'set-device-mappings';
export const SET_DEVICE_MAPPINGS_RESULT = `${SET_DEVICE_MAPPINGS}/result`;
export const SET_DEVICE_MAPPINGS_ERROR = `${SET_DEVICE_MAPPINGS}/error`;

export const RESET_DEVICE_MAPPINGS = 'reset-device-mappings';
export const RESET_DEVICE_MAPPINGS_RESULT = `${RESET_DEVICE_MAPPINGS}/result`;
export const RESET_DEVICE_MAPPINGS_ERROR = `${RESET_DEVICE_MAPPINGS}/error`;

export const COPY_DEVICE_MAPPING_FROM_GLOBAL = 'copy-device-mapping-from-global';
export const COPY_DEVICE_MAPPING_FROM_GLOBAL_RESULT = `${COPY_DEVICE_MAPPING_FROM_GLOBAL}/result`;
export const COPY_DEVICE_MAPPING_FROM_GLOBAL_ERROR = `${COPY_DEVICE_MAPPING_FROM_GLOBAL}/error`;

export const GET_CATALOG = 'get-catalog';
export const GET_CATALOG_RESULT = `${GET_CATALOG}/result`;
export const GET_CATALOG_ERROR = `${GET_CATALOG}/error`;

export const GET_SEPARATE_HR_DEVICE_AVAILABILITY = 'get-separate-hr-device-availability';
export const GET_SEPARATE_HR_DEVICE_AVAILABILITY_RESULT = `${GET_SEPARATE_HR_DEVICE_AVAILABILITY}/result`;
export const GET_SEPARATE_HR_DEVICE_AVAILABILITY_ERROR = `${GET_SEPARATE_HR_DEVICE_AVAILABILITY}/error`;
export const GET_OFFERED_VITALS = 'get-offered-vitals';
export const GET_OFFERED_VITALS_RESULT = `${GET_OFFERED_VITALS}/result`;
export const GET_OFFERED_VITALS_ERROR = `${GET_OFFERED_VITALS}/error`;

export const GET_SMARTMETER_SKUS = 'get-smartmeter-skus';
export const GET_SMARTMETER_SKUS_RESULT = `${GET_SMARTMETER_SKUS}/result`;

export const CONFIGURE_SMARTMETER_SKU = 'configure-smartmeter-sku';
export const CONFIGURE_SMARTMETER_SKU_RESULT = `${CONFIGURE_SMARTMETER_SKU}/result`;

export const SET_GLOBAL_ORDERABLE = 'set-global-orderable';
export const SET_GLOBAL_ORDERABLE_RESULT = `${SET_GLOBAL_ORDERABLE}/result`;
export const SET_GLOBAL_ORDERABLE_ERROR = `${SET_GLOBAL_ORDERABLE}/error`;

export const DELETE_ORG_ORDERABLE = 'delete-org-orderable';
export const DELETE_ORG_ORDERABLE_RESULT = `${DELETE_ORG_ORDERABLE}/result`;
export const DELETE_ORG_ORDERABLE_ERROR = `${DELETE_ORG_ORDERABLE}/error`;

export const WAIVER_PENDING_RETURN = 'waiver-pending-return';
export const WAIVER_PENDING_RETURN_RESULT = `${WAIVER_PENDING_RETURN}/result`;
export const WAIVER_PENDING_RETURN_ERROR = `${WAIVER_PENDING_RETURN}/error`;

export const REVOKE_WAIVER_PENDING_RETURN = 'revoke-waiver-pending-return';
export const REVOKE_WAIVER_PENDING_RETURN_RESULT = `${REVOKE_WAIVER_PENDING_RETURN}/result`;
export const REVOKE_WAIVER_PENDING_RETURN_ERROR = `${REVOKE_WAIVER_PENDING_RETURN}/error`;

export const GET_WAIVED_PENDING_RETURNS = 'get-waived-pending-returns';
export const GET_WAIVED_PENDING_RETURNS_RESULT = `${GET_WAIVED_PENDING_RETURNS}/result`;
export const GET_WAIVED_PENDING_RETURNS_ERROR = `${GET_WAIVED_PENDING_RETURNS}/error`;

export const GET_ALL_WAIVED_PENDING_RETURNS = 'get-all-waived-pending-returns';
export const GET_ALL_WAIVED_PENDING_RETURNS_RESULT = `${GET_ALL_WAIVED_PENDING_RETURNS}/result`;

export const PLACE_SMARTMETER_ORDER = 'place-smartmeter-order';
export const PLACE_SMARTMETER_ORDER_RESULT = `${PLACE_SMARTMETER_ORDER}/result`;

export const PLACE_SMARTMETER_ORDER_PREVIEW = 'place-smartmeter-order-preview';
export const PLACE_SMARTMETER_ORDER_PREVIEW_RESULT = `${PLACE_SMARTMETER_ORDER_PREVIEW}/result`;

export const CANCEL_SMARTMETER_ORDER = 'cancel-smartmeter-order';
export const CANCEL_SMARTMETER_ORDER_RESULT = `${CANCEL_SMARTMETER_ORDER}/result`;

export const shippingActions = {
  getPatientsWithoutKit: params => {
    return {
      [API_CALL]: {
        method: 'GET',
        endpoint: 'portal/patients/enrolled-without-kits',
        params,
      },
      type: GET_PATIENTS_WITHOUT_KIT,
    };
  },

  transferKit: data => {
    return {
      [API_CALL]: {
        method: 'POST',
        endpoint: 'portal/kits/transfer',
        data,
      },
      type: TRANSFER_KITS,
    };
  },
  createShipment: data => {
    return {
      [API_CALL]: {
        method: 'POST',
        endpoint: 'portal/kits/shipments',
        data,
      },
      type: CREATE_SHIPMENT,
    };
  },

  editShipment: (id, data) => {
    return {
      [API_CALL]: {
        method: 'PUT',
        endpoint: `portal/kits/shipments/${id}`,
        data,
      },
      type: EDIT_SHIPMENT,
    };
  },

  getShipments: params => {
    return {
      [API_CALL]: {
        method: 'GET',
        endpoint: 'portal/kits/shipments',
        params,
      },
      type: GET_SHIPMENTS,
    };
  },

  getShipmentDetails: id => {
    return {
      [API_CALL]: {
        method: 'GET',
        endpoint: `portal/kits/shipments/${id}`,
      },
      type: GET_SHIPMENT_DETAILS,
    };
  },

  updateShipmentStatus: (id, data) => {
    return {
      [API_CALL]: {
        method: 'PUT',
        endpoint: `portal/kits/shipments/${id}/status`,
        data,
      },
      type: UPDATE_SHIPMENT_STATUS,
    };
  },

  getInventoryList: params => {
    return {
      [API_CALL]: {
        method: 'GET',
        endpoint: 'portal/kits/inventory',
        params,
      },
      type: GET_INVENTORY_LIST,
    };
  },
  getInventorySummary: () => {
    return {
      [API_CALL]: {
        method: 'GET',
        endpoint: 'portal/kits/inventory/summary',
      },
      type: GET_INVENTORY_SUMMARY,
    };
  },

  getOrders: params => {
    return {
      [API_CALL]: {
        method: 'GET',
        endpoint: 'portal/kits/orders',
        params,
      },
      type: GET_ORDERS,
    };
  },

  createOrder: data => {
    return {
      [API_CALL]: {
        method: 'POST',
        endpoint: 'portal/kits/orders',
        data,
      },
      type: CREATE_ORDER,
    };
  },

  editOrder: (id, data) => {
    return {
      [API_CALL]: {
        method: 'PUT',
        endpoint: `portal/kits/orders/${id}`,
        data,
      },
      type: EDIT_ORDER,
    };
  },

  deleteOrder: id => {
    return {
      [API_CALL]: {
        method: 'DELETE',
        endpoint: `portal/kits/orders/${id}`,
      },
      type: DELETE_ORDER,
    };
  },

  getOrder: id => {
    return {
      [API_CALL]: {
        method: 'GET',
        endpoint: `portal/kits/orders/${id}`,
      },
      type: GET_ORDER,
    };
  },

  getOrderableDevices: () => {
    return {
      [API_CALL]: {
        method: 'GET',
        endpoint: 'portal/kits/orders/orderable-devices',
      },
      type: GET_ORDERABLE_DEVICES,
    };
  },

  getOrderInvoices: params => {
    return {
      [API_CALL]: {
        method: 'GET',
        endpoint: 'portal/kits/orders/invoices',
        params,
      },
      type: GET_ORDER_INVOICES,
    };
  },
  
  getDeviceTimeline: deviceId => {
    return {
      [API_CALL]: {
        method: 'GET',
        endpoint: `portal/kits/device/${deviceId}/timeline`,
      },
      type: GET_DEVICE_TIMELINE,
    };
  },

  getInvoices: params => {
    return {
      [API_CALL]: {
        method: 'GET',
        endpoint: 'portal/kits/orders/invoices',
        params,
      },
      type: GET_INVOICES,
    };
  },

  acceptOrder: (order_uuid, data) => {
    return {
      [API_CALL]: {
        method: 'POST',
        endpoint: `/portal/kits/orders/${order_uuid}/review/accept`,
        data,
      },
      type: ACCEPT_ORDER,
    };
  },

  rejectOrder: (order_uuid, data) => {
    return {
      [API_CALL]: {
        method: 'POST',
        endpoint: `/portal/kits/orders/${order_uuid}/review/reject`,
        data,
      },
      type: REJECT_ORDER,
    };
  },

  getReviewQueue: params => {
    return {
      [API_CALL]: {
        method: 'GET',
        endpoint: 'portal/kits/orders/review-queue',
        params,
      },
      type: GET_REVIEW_QUEUE,
    };
  },

  getDeliveryFollowups: params => {
    return {
      [API_CALL]: {
        method: 'GET',
        endpoint: 'portal/kits/deliveries/followup',
        params,
      },
      type: GET_DELIVERY_FOLLOWUPS,
    };
  },

  setDeliveryFollowup: (patient_uuid, data) => {
    return {
      [API_CALL]: {
        method: 'POST',
        endpoint: `portal/kits/deliveries/followup/${patient_uuid}`,
        data,
      },
      type: SET_DELIVERY_FOLLOWUP,
    };
  },

  getPendingReturns: params => {
    return {
      [API_CALL]: {
        method: 'GET',
        endpoint: 'portal/kits/orders/pending-returns',
        params,
      },
      type: GET_PENDING_RETURNS,
    };
  },

  waiverPendingReturn: (enrollment_uuid, data) => {
    return {
      [API_CALL]: {
        method: 'POST',
        endpoint: `portal/kits/orders/pending-returns/${enrollment_uuid}/waiver`,
        data,
      },
      type: WAIVER_PENDING_RETURN,
    };
  },

  revokePendingReturnWaiver: (enrollment_uuid) => {
    return {
      [API_CALL]: {
        method: 'DELETE',
        endpoint: `portal/kits/orders/pending-returns/${enrollment_uuid}/waiver`,
      },
      type: REVOKE_WAIVER_PENDING_RETURN,
    };
  },

  getWaivedPendingReturns: enrollment_uuid => {
    return {
      [API_CALL]: {
        method: 'GET',
        endpoint: `/portal/kits/orders/pending-returns/${enrollment_uuid}/waiver`,
      },
      type: GET_WAIVED_PENDING_RETURNS,
    };
  },

  getAllWaivedPendingReturns: () => {
    return {
      [API_CALL]: {
        method: 'GET',
        endpoint: `/portal/kits/orders/pending-returns/waived`,
      },
      type: GET_ALL_WAIVED_PENDING_RETURNS,
    };
  },

  getKitsAwaitingBulkReturn: params => {
    return {
      [API_CALL]: {
        method: 'GET',
        endpoint: 'portal/kits/orders/awaiting-bulk-return',
        params,
      },
      type: GET_KITS_AWAITING_BULK_RETURN,
    };
  },

  getKitsForInspection: params => {
    return {
      [API_CALL]: {
        method: 'GET',
        endpoint: 'portal/kits/orders/awaiting-inspection',
        params,
      },
      type: GET_KITS_FOR_INSPECTION,
    };
  },

  releaseKitFromInspection: (kit_uuid) => {
    return {
      [API_CALL]: {
        method: 'POST',
        endpoint: `/portal/kits/kit/${kit_uuid}/release-from-inspection`,
      },
      type: RELEASE_KIT_FROM_INSPECTION,
    };
  },

  getDeviceMappings: params => {
    return {
      [API_CALL]: {
        method: 'GET',
        endpoint: 'portal/kits/orders/device-mappings',
        params,
      },
      type: GET_DEVICE_MAPPINGS,
    };
  },

  setDeviceMappings: data => {
    return {
      [API_CALL]: {
        method: 'PUT',
        endpoint: 'portal/kits/orders/device-mappings',
        data,
      },
      type: SET_DEVICE_MAPPINGS,
    };
  },

  resetDeviceMappings: params => {
    return {
      [API_CALL]: {
        method: 'DELETE',
        endpoint: 'portal/kits/orders/device-mappings',
        params,
      },
      type: RESET_DEVICE_MAPPINGS,
    };
  },

  copyDeviceMappingFromGlobal: data => {
    return {
      [API_CALL]: {
        method: 'PUT',
        endpoint: `portal/kits/orders/device-mappings/seed-from-global`,
        data,
      },
      type: COPY_DEVICE_MAPPING_FROM_GLOBAL,
    };
  },

  getCatalog: params => {
    return {
      [API_CALL]: {
        method: 'GET',
        endpoint: 'portal/kits/orders/catalog',
        params,
      },
      type: GET_CATALOG,
    };
  },

  getSeparateHrDeviceAvailability: data => {
    return {
      [API_CALL]: {
        method: 'POST',
        endpoint: 'portal/kits/orders/separate-hr-device-availability',
        data,
        // An answer for an older draft must not land after the current one.
        latest: true,
        // Read-only, so transient failures retry like a GET.
        idempotent: true,
      },
      type: GET_SEPARATE_HR_DEVICE_AVAILABILITY,
    };
  },

  getOfferedVitals: params => {
    return {
      [API_CALL]: {
        method: 'GET',
        endpoint: 'portal/kits/orders/catalog/offered-vitals',
        params,
        // An answer for an earlier organization must not land after the current one.
        latest: true,
      },
      type: GET_OFFERED_VITALS,
    };
  },

  smartmeterBootstrap: params => {
    return {
      [API_CALL]: {
        method: 'POST',
        endpoint: 'portal/v1/superadmin/smartmeter/dev-bootstrap',
        params,
      },
      type: 'smartmeter-bootstrap',
    };
  },

  getSmartmeterSkus: params => {
    return {
      [API_CALL]: {
        method: 'GET',
        endpoint: 'portal/kits/orders/catalog/smartmeter-skus',
        params,
      },
      type: GET_SMARTMETER_SKUS,
    };
  },

  configureSmartmeterSku: (data) => {
    return {
      [API_CALL]: {
        method: 'PUT',
        endpoint: '/portal/kits/orders/catalog/smartmeter-sku',
        data,
      },
      type: CONFIGURE_SMARTMETER_SKU,
    };
  },

  setGlobalOrderable: data => {
    return {
      [API_CALL]: {
        method: 'PUT',
        endpoint: 'portal/kits/orders/catalog/global',
        data,
      },
      type: SET_GLOBAL_ORDERABLE,
    };
  },

  deleteOrgOrderable: params => {
    return {
      [API_CALL]: {
        method: 'DELETE',
        endpoint: 'portal/kits/orders/catalog/org',
        params,
      },
      type: DELETE_ORG_ORDERABLE,
    };
  },

  placeSmartmeterOrder: (order_uuid, data) => {
    return {
      [API_CALL]: {
        method: 'POST',
        endpoint: `portal/kits/orders/${order_uuid}/smartmeter-fulfill`,
        data,
      },
      type: PLACE_SMARTMETER_ORDER,
    };
  },
  cancelSmartmeterOrder: order_uuid => {
    return {
      [API_CALL]: {
        method: 'DELETE',
        endpoint: `portal/kits/orders/${order_uuid}/smartmeter-fulfill`,
      },
      type: CANCEL_SMARTMETER_ORDER,
    };
  },
  placeSmartmeterOrderPreview: (order_uuid) => {
    return {
      [API_CALL]: {
        method: 'GET',
        endpoint: `portal/kits/orders/${order_uuid}/smartmeter-fulfill/preview`,
      },
      type: PLACE_SMARTMETER_ORDER_PREVIEW,
    };
  },
  // Override-aware preview: evaluates prospective item_sku_overrides exactly
  // as fulfillment would, surfacing blockers (e.g. sku_without_device) before
  // anything is submitted.
  placeSmartmeterOrderPreviewWithOverrides: (order_uuid, data) => {
    return {
      [API_CALL]: {
        method: 'POST',
        endpoint: `portal/kits/orders/${order_uuid}/smartmeter-fulfill/preview`,
        data,
      },
      type: PLACE_SMARTMETER_ORDER_PREVIEW,
    };
  },
};
